/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */ "use strict";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _AnimatedInterpolation = _interopRequireDefault(require("./AnimatedInterpolation"));
var _AnimatedValue = _interopRequireDefault(require("./AnimatedValue"));
var _AnimatedWithChildren = _interopRequireDefault(require("./AnimatedWithChildren"));
var AnimatedSubtraction = /*#__PURE__*/ function(_AnimatedWithChildren_default) {
    _inherits(AnimatedSubtraction, _AnimatedWithChildren_default);
    var _super = _create_super(AnimatedSubtraction);
    function AnimatedSubtraction(a, b) {
        _class_call_check(this, AnimatedSubtraction);
        var _this;
        _this = _super.call(this);
        _this._a = typeof a === "number" ? new _AnimatedValue.default(a) : a;
        _this._b = typeof b === "number" ? new _AnimatedValue.default(b) : b;
        return _this;
    }
    _create_class(AnimatedSubtraction, [
        {
            key: "__makeNative",
            value: function __makeNative(platformConfig) {
                this._a.__makeNative(platformConfig);
                this._b.__makeNative(platformConfig);
                _get(_get_prototype_of(AnimatedSubtraction.prototype), "__makeNative", this).call(this, platformConfig);
            }
        },
        {
            key: "__getValue",
            value: function __getValue() {
                return this._a.__getValue() - this._b.__getValue();
            }
        },
        {
            key: "interpolate",
            value: function interpolate(config) {
                return new _AnimatedInterpolation.default(this, config);
            }
        },
        {
            key: "__attach",
            value: function __attach() {
                this._a.__addChild(this);
                this._b.__addChild(this);
            }
        },
        {
            key: "__detach",
            value: function __detach() {
                this._a.__removeChild(this);
                this._b.__removeChild(this);
                _get(_get_prototype_of(AnimatedSubtraction.prototype), "__detach", this).call(this);
            }
        },
        {
            key: "__getNativeConfig",
            value: function __getNativeConfig() {
                return {
                    type: "subtraction",
                    input: [
                        this._a.__getNativeTag(),
                        this._b.__getNativeTag()
                    ]
                };
            }
        }
    ]);
    return AnimatedSubtraction;
}(_AnimatedWithChildren.default);
var _default = AnimatedSubtraction;
exports.default = _default;
module.exports = exports.default;
